export const payload = {
  receiveMutation: 'RECEIVE_PP',
  receiveMetadataMutation: 'RECEIVE_PP_METADATA',
  savingMutation: 'SAVING_PP',
  incrementMutation: 'INCREMENT_PP_COUNT',
  updatingMutation: 'UPDATING_PP',
  resetMetaMutation: 'RESET_PP_META',
  clearMutation: 'CLEAR_PP_STATE',
  moduleName: 'pp',
  endpoint: 'pps'
}
